import Card from "@rio-cloud/rio-uikit/Card";
import Spinner from "@rio-cloud/rio-uikit/Spinner";
import { useT } from "@hooks";

interface PanelShellProps {
  loading: boolean;
  loadingLabel: string;
  hasData: boolean;
  className?: string;
  skeleton?: React.ReactNode;
  children: React.ReactNode;
}

interface PanelLoaderProps {
  label: string;
}

const PanelLoader = ({ label }: PanelLoaderProps) => {
  const t = useT();
  return (
    <Card className="padding-30 display-flex justify-content-center align-items-center gap-10 min-height-150">
      <Spinner isInline />
      <span className="text-size-16 text-bold text-color-gray">{t("dashboard.panel.loading", { label })}</span>
    </Card>
  );
};

const PanelEmptyState = ({ label }: PanelLoaderProps) => {
  const t = useT();
  return (
    <Card className="padding-30 display-flex flex-column justify-content-center align-items-center gap-10 min-height-150">
      <span className="rioglyph rioglyph-info-sign text-size-28 text-color-primary" aria-hidden="true" />
      <span className="text-size-14 text-color-gray text-center">{t("dashboard.panel.noData", { label })}</span>
    </Card>
  );
};

export default function PanelShell({
  loading,
  loadingLabel,
  hasData,
  className = "",
  skeleton,
  children,
}: Readonly<PanelShellProps>) {
  if (loading) {
    return <div className={className}>{skeleton ?? <PanelLoader label={loadingLabel} />}</div>;
  }

  if (!hasData) {
    return (
      <div className={className}>
        <PanelEmptyState label={loadingLabel} />
      </div>
    );
  }

  return <div className={className}>{children}</div>;
}
